'use client'

import { useId } from 'react'
import cn from 'classnames'
import styles from './index.module.scss'

type CheckBoxFieldProps = {
  name: string
  checked: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void

  /** Use this for normal React content (preferred) */
  label?: React.ReactNode

  /** Use this only if your translations are HTML strings */
  labelHtml?: string

  multiline?: boolean
  hasError?: boolean
  disabled?: boolean
  className?: string
  id?: string
}

export default function CheckBoxField({
  name,
  checked,
  onChange,
  label,
  labelHtml,
  multiline = false,
  hasError = false,
  disabled = false,
  className,
  id,
}: CheckBoxFieldProps) {
  const autoId = useId()
  const inputId = id ?? autoId

  return (
    <label
      htmlFor={inputId}
      className={cn(
        styles.control,
        className,
        multiline && styles.multiline,
        !checked && hasError && styles.hasError,
        disabled && styles.disabled,
      )}
    >
      <input
        id={inputId}
        type="checkbox"
        name={name}
        className={cn(styles.checkbox, multiline && styles.multiline)}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        aria-invalid={(!checked && hasError) || undefined}
      />

      {label != null ? (
        <span>{label}</span>
      ) : labelHtml ? (
        <span dangerouslySetInnerHTML={{ __html: labelHtml }} />
      ) : (
        <span />
      )}
    </label>
  )
}
